// frontend/src/App.js
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import ClientLayout from './components/ClientLayout';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import ReceiptControl from './components/ReceiptControl';
import PriceControl from './components/PriceControl';
import FinanceControl from './components/FinanceControl';


function App() {
    const [token, setToken] = useState(localStorage.getItem('token'));

    const handleSetToken = (newToken) => {
        if (newToken) {
            localStorage.setItem('token', newToken);
        } else {
            localStorage.removeItem('token');
        }
        setToken(newToken);
    };

    return (
        <BrowserRouter>
        <Routes>
            {/* If there is a token, the root path redirects to /dashboard */}
            <Route path="/" element={!token ? <LoginPage setToken={handleSetToken} /> : <Navigate to="/dashboard" />} />

            {/* Protected Client Area Routes */}
            <Route element={token ? <ClientLayout setToken={handleSetToken} /> : <Navigate to="/" />} >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/price-control" element={<PriceControl />} />
              <Route path="/finance-control" element={<FinanceControl />} />
              <Route path="/upload-receipt" element={<ReceiptControl />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
        </Routes>
        </BrowserRouter>
    );
}

const LoginPage = ({ setToken }) => {
  const [authPage, setAuthPage] = useState("login");
  
  if(authPage === "signup"){
    return (  
      <div>
        <Register 
          setToken={setToken} 
          onBackToLogin={() => setAuthPage("login")}
        />
      </div>
    );
  }
  
  return (  
    <div>
      <Login 
        setToken={setToken} 
        onGoToSignUp={() => setAuthPage("signup")}
      />
    </div>
  );
};

export default App;